import { useQuery } from "react-query";
import { RunnableFetchOptions } from "../models/types";
import queryClient, { QueryKey } from "../state/QueryStore";
import { getRunnable, getRunnables } from "../services/RunnableService";

export const useRunnables = (params: RunnableFetchOptions) => {
  return useQuery([QueryKey.Runnable, params], async () => {
    const { data } = await getRunnables(params);
    return data;
  });
};

export const fetchRunnables = (params: RunnableFetchOptions) => {
  return queryClient.fetchQuery([QueryKey.Runnable, params], async () => {
    const { data } = await getRunnables(params);
    return data;
  });
};

export const useRunnable = (id: string) => {
  return useQuery([QueryKey.Runnable, id], async () => {
    if (!id) return;
    const { data } = await getRunnable(id);
    return data;
  });
};

export const fetchRunnable = (id: string) => {
  return queryClient.fetchQuery([QueryKey.Runnable, id], async () => {
    const { data } = await getRunnable(id);
    return data;
  });
};

export const searchRunnables = async (searchText: string) => {
  const runnables = await fetchRunnables({ search: searchText });
  return runnables.results;
};
